import { render, staticRenderFns } from "./termsconditions.vue?vue&type=template&id=2f2b3d02"
import script from "./termsconditions.vue?vue&type=script&lang=js"
export * from "./termsconditions.vue?vue&type=script&lang=js"
import style0 from "./termsconditions.vue?vue&type=style&index=0&id=2f2b3d02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports